import { useIsAppConfigLoading } from '@src/providers/AppConfigProvider'
import { useEffect, type JSX } from 'react'
import { useNavigate } from 'react-router-dom'

const AuthPage = (): JSX.Element => {
  const navigate = useNavigate()

  // App config is loaded by AppConfigProvider
  // User and preferences are loaded by UserProvider and PreferencesProvider
  const isLoadingConfig = useIsAppConfigLoading()

  // Navigate when config is loaded (user is loaded by UserProvider)
  useEffect(() => {
    if (!isLoadingConfig) {
      navigate('/home', { replace: true })
    }
  }, [isLoadingConfig, navigate])

  return <div />
}

export default AuthPage
